define(function (require) {

    require('es6-promise').polyfill();

    require("modals");
    require("ie");

    require("ga");
    require('!style-loader!css-loader!stylus-loader!../styles/required.styl');

    var domReady = require("domready");
    var renderer = require("renderer");
    var markdownHandler = require("markdown-handler");
    //var css = require("!css!stylus!../styles/default.styl");
    require("!style-loader!css-loader!stylus-loader!../styles/default-modules.styl");

    var initRendering = function() {
        var campaignMarkdownObject = document.getElementById("campaign-markdown");
        var formOptionsObject = document.getElementById("campaign-form-options");
        var loginMarkdownObject = document.getElementById("login-markdown");
        if(formOptionsObject){        
            var formOptionsTxt = document.getElementById("campaign-form-options").innerHTML;     
            var formOptions = JSON.parse(formOptionsTxt);
            for(var optKey in formOptions){
                MBGF[optKey] = formOptions[optKey];
            }
        }

        if (campaignMarkdownObject) {

            var campaignMarkdown = document.getElementById("campaign-markdown").textContent;
            if (typeof campaignMarkdown == "undefined") {
                // IE
                campaignMarkdown = document.getElementById("campaign-markdown").innerHTML;
            }

            renderer.render(campaignMarkdown, "render-container", function () {
                
                if (localStorage && localStorage.timer == "true") {
                    var now = new Date();
                    var delta = now.getTime() - MBGF.initTime.getTime();
                    console.log("It took %s ms to display the page", delta);
                }

                var container = document.querySelector("#render-container");
                MBGF.formid = container.getAttribute('data-formid');
                container.style.display = "block";

                // ****************************
                // * Max submit message       *
                // ****************************
                if (MBGF.useSubmitMax) {
                    var maxSubmitContent = document.createElement('div');
                    maxSubmitContent.classList.add('mbgf-column-row');
                    maxSubmitContent.innerHTML = '<div class="mbgf-col-sm-12"><div class="submit-max-container">' + MBGF.submitMaxMessage + '</div></div>';
                    container.prepend(maxSubmitContent);
                }

                var loadingLayer = document.querySelector("#loadingLayer");

                if( loadingLayer ) {
                    var newClass = loadingLayer.getAttribute('class').replace(/(|\s)hidden(|\s)/g, "") + ' hidden';
                    loadingLayer.setAttribute('class', newClass);
                }
                jQuery("#mbgf-form").trigger("mbgfFormDidLoad");
            });

        }
        else if (loginMarkdownObject) {
            var loginMarkdown = loginMarkdownObject.textContent;

            if (typeof loginMarkdown == "undefined") {
                loginMarkdown = loginMarkdownObject.innerHTML;
            }

            var container = document.getElementById("login-content-container");

            if (loginMarkdown.length > 0) {
                renderer.render(loginMarkdown, "login-content-container", function () {
                    container.style.display = "block";
                    document.querySelector("#render-container").style.display = "block";
                });
            }
            else {
                container.style.display = "block";
                document.querySelector("#render-container").style.display = "block";
            }

            var submitButton = document.querySelector(".campaign-login-btn");
            var loginCode = document.querySelector("#txtLogin");

            if (loginCode.value.match(/[^A-Za-z0-9]/g) || loginCode.value.length == 0) {
                submitButton.setAttribute("disabled", "true");
            }

            document.getElementById("txtLogin").addEventListener("keyup", function () {

                if (this.value.match(/[^A-Za-z0-9]/g) || this.value.length == 0) {
                    submitButton.setAttribute("disabled", "true");
                } else {
                    submitButton.removeAttribute("disabled");
                }

            }, false);
        } else {
            var loadingLayer = document.querySelector("#loadingLayer");
            if( loadingLayer ) {
                var newClass = loadingLayer.getAttribute('class').replace(/(|\s)hidden(|\s)/g, "") + ' hidden';
                loadingLayer.setAttribute('class', newClass);
            }

            jQuery("#mbgf-form").trigger("mbgfFormDidLoad");
        }
    };

    domReady(function () {
        if(document.getElementById('financial-form-selector')) {
            var select = document.getElementById('financial-form-selector');
            select.onchange = function() {
                var jqXHR = markdownHandler.getFormMarkdown(this.value);
                jqXHR.done(function() {
                    initRendering();
                });
            };
        }
        initRendering();
    });

    /**
     * Expose global function to manipulate the markdown text
     * @param  {[string]} markdown [New markdown text to be rendered]
     */
    window.GFRenderMarkdown = window.GFRenderMarkdown || function(markdown) {
        var container = document.querySelector("#render-container");
        container.innerHTML = '<script type="text" id="campaign-markdown">' + markdown + '</script>';
        initRendering(); // Trigger re-render        
    };

});



// WEBPACK FOOTER //
// ./js-src/markdown-editor/scripts/main.js